var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "debugWindow",
      staticStyle: { top: "2px", left: "10px" },
      attrs: { id: "debugWindow" }
    },
    [
      _c("div", { attrs: { id: "debugWindowHeader" } }, [
        _vm._v("Окно отладки")
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticStyle: { width: "90px" }, on: { click: _vm.forTest } },
        [_vm._v("Добавить planeGroup")]
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticStyle: { width: "90px" }, on: { click: _vm.forTest2 } },
        [_vm._v("Добавить planeGroup")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }